<div class="public-search-toolbar">
  <form class="public-search-toolbar__field" @submit.prevent="submitSearch">
    <i class="bi bi-search"></i>
    <input
      :value="modelValue"
      type="search"
      :placeholder="resolvedPlaceholder"
      :aria-label="resolvedAriaLabel"
      @input="updateSearchQuery"
    />
    <button type="submit">{{ resolvedSubmitLabel }}</button>
  </form>

  <div v-if="filters.length || scopeOptions.length" class="public-search-toolbar__filter-row">
    <div v-if="filters.length" class="public-search-toolbar__filters" :aria-label="$t('search.resultFilters')">
      <button
        v-for="filter in filters"
        :key="filter.key"
        type="button"
        class="public-search-filter"
        :class="{ 'is-active': isFilterActive(filter.key) }"
        :aria-pressed="isFilterActive(filter.key)"
        @click="toggleFilter(filter.key)"
      >
        <i :class="filter.icon"></i>
        <span>{{ getFilterLabel(filter) }}</span>
        <b>{{ getFilterCount(filter.key) }}</b>
      </button>
    </div>

    <RadioToggle
      v-if="scopeOptions.length"
      class="public-search-toolbar__scopes"
      :model-value="activeScope"
      :options="scopeOptions"
      :aria-label="$t('search.tournamentPeriod')"
      @update:model-value="setScope"
    />
  </div>

  <div v-if="showDropdownResults && showResultsPanel" class="public-search-toolbar__body">
    <div
      v-if="results.length"
      class="public-search-toolbar__results public-hover-lift-scroll-area"
      :aria-label="$t('search.results')"
    >
      <PublicSearchResultCard
        v-for="item in results"
        :key="`${item.type}-${item.title}`"
        :item="item"
        compact
      />
    </div>

    <div v-else class="public-search-toolbar__empty">
      <i class="bi bi-search"></i>
      <span>{{ resolvedEmptyText }}</span>
    </div>

    <router-link
      v-if="canShowMore"
      :to="moreRoute"
      class="public-search-toolbar__more"
    >
      {{ resolvedMoreLabel }} ({{ totalResultsCount }})
    </router-link>
  </div>

  <div v-else-if="showHints && hints.length" class="public-search-toolbar__hint">
    <span v-for="hint in hints" :key="hint.labelKey || hint.label">
      <i :class="hint.icon"></i>
      {{ getHintLabel(hint) }}
    </span>
  </div>
</div>
